import { createFileRoute } from "@tanstack/react-router";
import { PharmaPage, pharmaHead } from "@/pages/PharmaPage";

export const Route = createFileRoute("/de/branchen/pharma-life-science")({
  head: () => pharmaHead("de"),
  component: () => <PharmaPage locale="de" />,
});
